import React, { ReactNode, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import T from "@components/translations/Translations";
import TranslationButtonGroup from "@components/translations/TranslationButtonGroup";

import "@/styles/Toolbar.scss";

interface ToolbarProps {
    label?: ReactNode;
    icon?: ReactNode;
}

const Toolbar = ({ label, icon }: ToolbarProps): React.JSX.Element => {
    const navigate = useNavigate();
    const handleHomeNavigation = useCallback((): void => {
        navigate("/home");
    }, [navigate]);

    return (
        <div className="toolbar">
            <div className="tb-content-wrapper">
                <button
                    aria-label="Home Button"
                    className="toolbar-link-home"
                    type="button"
                    onClick={handleHomeNavigation}
                >
                    {icon || "EPP"}
                </button>
                <div className="divider">&nbsp;</div>
                <span>{label || <T tKey="Toolbar_Title" />}</span>
            </div>
            <div>
                <TranslationButtonGroup />
            </div>
        </div>
    );
};

export default React.memo(Toolbar);
